var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",style:(_vm.containerStyle)},[_c('div',{ref:"content",style:(_vm.contentStyle)},[_vm._t("default")],2),(_vm.shouldShowLink)?_c('FlotoAnchorLink',{on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.$t('read'))+" "+_vm._s(_vm.$t(_vm.expanded ? 'less' : 'more'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }